import { render } from "./FrasesDelDia.vue?vue&type=template&id=3b6e2776&scoped=true"
import script from "./FrasesDelDia.vue?vue&type=script&lang=js"
export * from "./FrasesDelDia.vue?vue&type=script&lang=js"

import "./FrasesDelDia.vue?vue&type=style&index=0&id=3b6e2776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6e2776"]])

export default __exports__